import { render, staticRenderFns } from "./driver-transaction.vue?vue&type=template&id=28a45e0d&"
import script from "./driver-transaction.vue?vue&type=script&lang=js&"
export * from "./driver-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports